import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/attendance`;
const token = localStorage.getItem("token");

// 📌 Configuration des headers avec le token
const config = {
  headers: {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  },
};

const attendanceServices = {
  /// 📌 GET
  // 🔹 Récupérer toutes les présences et absences
  getAllAttendances: async () => {
    try {
      const response = await axios.get(`${apiUrl}/getAllAttendances`, config);
      return response.data;
    } catch (error) {
      console.error("❌ Erreur lors de la récupération des présences :", error);
      throw error;
    }
  },

  // 🔹 Récupérer toutes les présences d’un groupe
  getGroupAttendances: async (groupId) => {
    try {
      const response = await axios.get(
        `${apiUrl}/getGroupAttendances/${groupId}`,
        config
      );
      return response.data;
    } catch (error) {
      console.error(
        "❌ Erreur lors de la récupération des présences du groupe :",
        error
      );
      throw error;
    }
  },

  // Récupérer toutes les présences d'un dojo
  getDojoAttendances: async (dojoId) => {
    try {
      const response = await axios.get(
        `${apiUrl}/getDojoAttendances/${dojoId}`,
        config
      );
      return response.data;
    } catch (error) {
      console.error(
        "❌ Erreur lors de la récupération des présences du dojo :",
        error
      );
      throw error;
    }
  },

  // 🔹 Récupérer les présences pour un club
  getClubAttendances: async (clubId) => {
    try {
      const response = await axios.get(
        `${apiUrl}/getClubAttendances/${clubId}`,
        config
      );
      return response.data;
    } catch (error) {
      console.error(
        "❌ Erreur lors de la récupération des présences du club :",
        error
      );
      throw error;
    }
  },

  // 🔹 Récupérer les présences d’un groupe pour une date spécifique
  getGroupAttendance: async (groupId, date) => {
    try {
      const response = await axios.get(
        `${apiUrl}/getGroupAttendance/${groupId}/${date}`,
        config
      );
      return response.data;
    } catch (error) {
      console.error(
        "❌ Erreur lors de la récupération de la présence du groupe :",
        error
      );
      throw error;
    }
  },

  // Statistiques de présence des clubs
  getAttendanceStatsByClub: async () => {
    try {
      const response = await axios.get(`${apiUrl}/stats-by-club`, config);
      return response.data;
    } catch (error) {
      console.error(
        "❌ Erreur lors de la récupération des statistiques de présence :",
        error
      );
      throw error;
    }
  },

  // Attendance par date
  getAttendanceCountByDate: async () => {
    try {
      const response = await axios.get(`${apiUrl}/count-by-date`, config);
      return response.data;
    } catch (error) {
      console.error(
        "❌ Erreur lors de la récupération des statistiques de présence :",
        error
      );
      throw error;
    }
  },

  /// 📌 POST
  // 🔹 Ajouter une nouvelle liste de présence pour un groupe et une date
  addAttendance: async (attendanceData) => {
    try {
      const response = await axios.post(
        `${apiUrl}/addAttendance`,
        attendanceData,
        config
      );
      return response.data;
    } catch (error) {
      console.error("❌ Erreur lors de l'ajout de la présence :", error);
      throw error;
    }
  },

  /// 📌 PUT
  // 🔹 Mettre à jour les présences d’un groupe pour une date donnée
  updateAttendance: async (groupId, date, presences) => {
    console.log("📡 Envoi de la mise à jour de présence :", {
      groupId,
      date,
      presences,
    });

    try {
      const response = await axios.put(
        `${apiUrl}/updateAttendance/${groupId}/${date}`,
        presences,
        config
      );
      return response.data;
    } catch (error) {
      console.error("❌ Erreur lors de la mise à jour de la présence :", error);
      throw error;
    }
  },

  /// 📌 DELETE
  // 🔹 Supprimer un enregistrement de présence pour un groupe et une date
  deleteAttendance: async (groupId, date) => {
    try {
      const response = await axios.delete(
        `${apiUrl}/deleteAttendance/${groupId}/${date}`,
        config
      );
      return response.data;
    } catch (error) {
      console.error("❌ Erreur lors de la suppression de la présence :", error);
      throw error;
    }
  },

  // Supprimer les enregistrements pour un groupe sur un mois
  deleteMonthlyAttendance: async (groupId, monthYYYYMM) => {
    try {
      const url = `${apiUrl}/deleteAttendanceByGroupByMonth/${groupId}/${encodeURIComponent(
        monthYYYYMM
      )}`;
      const { data } = await axios.delete(url, config);
      return data;
    } catch (error) {
      console.error("❌ Erreur lors de la suppression des présences :", error);
      throw error;
    }
  },
};

export default attendanceServices;
